export const WORKFLOW_STORAGE_KEY = 'shop_workflow';

// This mirrors the backend default only as a startup fallback. The backend
// remains the source of truth and refreshes this value at login/navigation.
export const DEFAULT_WORKFLOW = {
    name: 'without_kovacici',
    processing_shops: ['dobrinja', 'bulevar'],
    next_shop: {dobrinja: 'bulevar', bulevar: 'administracija'},
    packing_shop: 'dobrinja',
    transfer_shops: ['bulevar'],
    delayed_shop: null,
    cash_register_warehouse_id: '2',
};

export const storeShopWorkflow = (workflow) => {
    if (workflow) {
        localStorage.setItem(WORKFLOW_STORAGE_KEY, JSON.stringify(workflow));
    }
};

export const getShopWorkflow = () => {
    const stored = localStorage.getItem(WORKFLOW_STORAGE_KEY);
    if (!stored) {
        return DEFAULT_WORKFLOW;
    }

    try {
        return JSON.parse(stored);
    } catch (error) {
        return DEFAULT_WORKFLOW;
    }
};

export const completedShopFromStatus = (status) => {
    const prefix = 'Završena - ';
    if (!status || !status.startsWith(prefix)) {
        return null;
    }
    return status.slice(prefix.length).toLowerCase();
};

export const finalStatusForCompletedShop = (status, workflow = getShopWorkflow()) => {
    const shop = completedShopFromStatus(status);
    if (!shop || !workflow.processing_shops.includes(shop)) {
        return null;
    }
    return shop === workflow.delayed_shop ? 'Ide sutra' : 'Pakovanje';
};

export const getCashRegisterWarehouseId = (workflow = getShopWorkflow()) => {
    if (workflow.cash_register_warehouse_id !== undefined) {
        return Number(workflow.cash_register_warehouse_id);
    }

    // Compatibility for a browser tab that still has a workflow cached before
    // cash_register_warehouse_id was added to the backend response.
    return {skenderija: 1, dobrinja: 2, bulevar: 3}[workflow.packing_shop];
};
